// extracted by mini-css-extract-plugin
export var boxItems = "_73-1";
export var boxItemsLg = "_73-2";
export var button = "_73-7";
export var buttonLg = "_73-8";
export var filterGroupBox = "_73-0";
export var icon = "_73-3";
export var iconSecondary = "_73-6";
export var iconWrapper = "_73-4";
export var iconWrapperLg = "_73-5";